import { Stack, Typography } from '@mui/material'

import Edit from 'assets/icons/EditBlue.png'
import Delete from 'assets/icons/Delete.png'

import { Event, InvoiceEvent } from 'store/invoices/invoices.types'
import { convertTimestampToDateAndTime } from 'pages/invoice/invoice.utils'
import ConfirmationDialog from 'components/confirmation-dialog/confirmation-dialog.component'
import { useState } from 'react'
import {
  useDeleteInvoiceEventMutation,
  useGetInvoiceByIdQuery,
} from 'store/invoices/invoices.api'

interface InvoiceDialogListItemProps {
  event: Event
  invoiceId: string
}

const InvoiceDialogListItem = ({
  event: { id: eventId, createdDate, notes, event },
  invoiceId,
}: InvoiceDialogListItemProps) => {
  const [deleteOpen, setDeleteOpen] = useState(false)

  const { refetch } = useGetInvoiceByIdQuery({ id: invoiceId })
  const [deleteEvent, { isError }] = useDeleteInvoiceEventMutation()

  const handleDelete = async () => {
    await deleteEvent({ invoiceId, eventId }).unwrap()

    if (!isError) {
      setDeleteOpen(false)
      refetch()
    }
  }

  return (
    <Stack
      direction="row"
      mb={2}
      justifyContent="space-between"
      alignItems={'center'}
    >
      <Stack>
        <Stack direction="row" spacing={1}>
          <Typography fontWeight={700}>
            {convertTimestampToDateAndTime(createdDate)?.date}
          </Typography>
          <Typography fontWeight={300}>
            {convertTimestampToDateAndTime(createdDate)?.time}
          </Typography>
        </Stack>
        <Typography fontWeight={300}>{notes}</Typography>
      </Stack>

      <Stack direction="row" spacing={1} alignItems={'center'}>
        {event === InvoiceEvent.CommentAdded && (
          <img
            src={Edit}
            alt="edit icon"
            width={36}
            height={36}
            style={{ cursor: 'pointer' }}
          />
        )}
        <img
          src={Delete}
          alt="delete icon"
          width={25}
          height={30}
          style={{ cursor: 'pointer' }}
          onClick={() => setDeleteOpen(true)}
        />
      </Stack>

      <ConfirmationDialog
        title="Delete Event"
        open={deleteOpen}
        handleClose={() => setDeleteOpen(false)}
        successBtnText="Delete"
        successBtnTextStyle={{ color: 'error' }}
        handleSuccessBtn={handleDelete}
      >
        Are you sure to delete the event?
      </ConfirmationDialog>
    </Stack>
  )
}

export default InvoiceDialogListItem
